'use client';

/**
 * Analytics Provider
 * Handles Google Analytics and Vercel Analytics initialization and listens for cookie consent changes
 */

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { initGA, removeGA, trackPageView } from '../lib/analytics';
import { Analytics } from '@vercel/analytics/react';

export default function AnalyticsProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Initialize GA on mount if consent is given
  useEffect(() => {
    initGA();

    // Listen for consent changes
    const handleConsentChange = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail === 'accepted') {
        initGA();
      } else if (customEvent.detail === 'declined') {
        removeGA();
      }
    };

    window.addEventListener('cookieConsentChanged', handleConsentChange);

    return () => {
      window.removeEventListener('cookieConsentChanged', handleConsentChange);
    };
  }, []);

  // Track page views on route change
  useEffect(() => {
    const url = pathname + searchParams.toString();
    trackPageView(url);
  }, [pathname, searchParams]);

  return <Analytics />;
}

